import Page from './Page/Page.tsx'

function App() {
  return (
    <div>
      <header>
        <Page />
      </header>
    </div>
  );
}

export default App;
